
export const prices = {
  title: "Prices 2026-2027 Academic Year",
  monthlyFees: {
    title: "Monthly Fees",
    subtitle: "10 payments/year · Includes teaching and materials",
    tableHeaders: {
      level: "Level",
      firstChild: "1st child",
      secondChild: "2nd child",
      thirdChild: "3rd child"
    },
    infantil: {
      title: "EARLY CHILDHOOD",
      ageRange: "3 to 5 years",
      schedule: "8:45h to 14:00h"
    },
    primaryC1: {
      title: "PRIMARY C1",
      ageRange: "6 to 8 years",
      schedule: "8:45h to 14:00h"
    },
    primaryC2: {
      title: "PRIMARY C2",
      ageRange: "9 to 11 years",
      schedule: "8:45h to 14:00h"
    }
  },
  enrollment: {
    title: "Enrollment",
    description: "Enrollment includes place reservation, administrative management and initial assessment",
    renewal: {
      title: "Renewal (current families)",
      subtitle: "Annual enrollment to confirm place",
      price: "350€",
      note: "Same for all siblings"
    },
    newStudents: {
      title: "New Students",
      subtitle: "First year enrollment",
      firstChild: {
        title: "First child",
        price: "700€"
      },
      siblings: {
        title: "2nd and 3rd child",
        price: "350€"
      }
    }
  },
  specialDiscounts: {
    title: "Special Discounts",
    earlyEnrollment: {
      title: "Early Enrollment",
      description: "Complete your enrollment before February 23rd and save 50€ per child",
      badge: "-50€"
    },
    annualPayment: {
      title: "Annual Payment",
      description: "Pay the full year in advance and get 200€ discount + 200€ voucher for birthdays or camps",
      badges: {
        discount: "-200€",
        voucher: "+200€ voucher"
      }
    }
  },
  discounts: {
    title: "Sibling Discounts",
    description: "Discounts automatically applied to monthly fees",
    secondChild: {
      title: "Second child",
      description: "20% off monthly fee"
    },
    thirdChild: {
      title: "Third child and beyond",
      description: "40% off monthly fee"
    }
  },
  additionalServices: {
    title: "Additional Services",
    transport: {
      title: "Taxi from Vigo",
      description: "Taxi from Vigo. Minimum 4 places. This is the only service requiring a booking commitment for the whole term; the price shown is monthly.",
      roundTrip: {
        title: "Round Trip",
        price: "225€/month"
      }
    },
    earlyBirds: {
      title: "Early Birds (Monday to Friday included)",
      monthly: {
        title: "Monthly",
        price: "75 €"
      },
      daily: {
        title: "Single days",
        price: "7 € (maximum monthly payment 75 €)"
      },
      description: "Daily service from 8:15"
    },
    food: {
      title: "Cafeteria",
      monthly: {
        title: "5 days/week",
        price: "195€"
      },
      threeDays: {
        title: "3 days/week",
        price: "125€"
      },
      twoDays: {
        title: "2 days/week",
        price: "90€"
      },
      daily: {
        title: "Single days",
        price: "15€"
      },
      description: "Lunch and morning snack following a balanced diet with organic and local products. Lunch plans are booked and paid monthly. Choose 5, 3 or 2 fixed days a week. After-lunch club included until 17:00 (16:00 on Fridays). Single days require 48 hours’ notice.",
      takeaway: {
        title: "Takeaway meals",
        description: "For the same price you can also order food for pickup anytime between 2:00 PM and 5:00 PM. Containers provided by Gándara."
      }
    },
    ludoteca: {
      title: "Ludoteca",
      schedule: "Schedule: 3:00 PM to 5:00 PM (Fridays until 4:00 PM)",
      freeService: "Free with lunch or extracurriculars",
      dayPass: {
        title: "Single day"
      },
      oneDay: {
        title: "One day/week"
      },
      twoDays: {
        title: "Two days/week"
      },
      fiveDays: {
        title: "Five days/week"
      },
      description: "Care and activities service after school hours"
    }
  },
  preEnrollment: {
    title: "Ready to take the next step?",
    subtitle: "Join our educational community in 3 simple steps",
    steps: "Pre-enrollment → Guided visit → Enrollment",
    ctaPrimary: "Request Pre-enrollment",
    ctaSecondary: "Book a Visit",
    note: "The pre-enrollment form does not imply commitment"
  }
};
